import { messages } from "../../lib/messages";
import type { CartItem } from "../../api/cart";

interface CartLineItemProps {
  item: CartItem;
  onChangeQty(qty: number): void;
}

/**
 * CartLineItem — строка корзины (docs/07-miniapp-ux.md §2.4): фото, название,
 * цена, счётчик количества, кнопка удаления. Недоступная позиция (available=false —
 * товар сняли с продажи или удалили из каталога) показывается приглушённой,
 * без счётчика: с ней можно только «Убрать».
 */
export function CartLineItem({ item, onChangeQty }: CartLineItemProps) {
  return (
    <li className={`flex items-center gap-3 rounded-card bg-surface p-2 ${item.available ? "" : "opacity-60"}`}>
      <div className="h-16 w-16 shrink-0 overflow-hidden rounded-card bg-bg">
        {item.image_url ? <img src={item.image_url} alt={item.title} className="h-full w-full object-cover" /> : null}
      </div>
      <div className="flex flex-1 flex-col gap-1">
        <p className="line-clamp-2 text-sm text-text">{item.title}</p>
        {item.available ? (
          <span className="text-sm text-hint">{item.price_text}</span>
        ) : (
          <span className="text-sm text-hint">{messages.outOfStock}</span>
        )}
      </div>
      {item.available ? (
        <div className="flex items-center gap-2">
          <button
            type="button"
            aria-label="Убавить"
            onClick={() => onChangeQty(item.qty - 1)}
            className="rounded-card bg-button px-2.5 py-1 text-button-text"
          >
            −
          </button>
          <span className="text-text">{item.qty}</span>
          <button
            type="button"
            aria-label="Добавить"
            onClick={() => onChangeQty(item.qty + 1)}
            className="rounded-card bg-button px-2.5 py-1 text-button-text"
          >
            +
          </button>
        </div>
      ) : (
        <button type="button" onClick={() => onChangeQty(0)} className="text-sm text-link">
          {messages.removeItem}
        </button>
      )}
    </li>
  );
}
